function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.794 27.871h-.002c-1.388-.398-2.396-1.66-2.396-3.153V18.77H3.321C1.543 18.77 0 17.356 0 15.487c0-1.868 1.543-3.282 3.32-3.282h7.397c1.33 0 2.53.792 3.049 1.974l5.8-8.704a3.341 3.341 0 013.7-1.344c1.387.397 2.394 1.658 2.394 3.151v4.923h3.019c1.777 0 3.321 1.413 3.321 3.282 0 1.87-1.544 3.282-3.321 3.282h-6.34a3.35 3.35 0 01-2.735-1.417l-6.115 9.174A3.333 3.333 0 0110.716 28c-.308 0-.619-.042-.923-.129zM21.02 11.623v3.864c0 .708.59 1.282 1.32 1.282h6.34c.73 0 1.321-.574 1.321-1.282 0-.708-.592-1.282-1.321-1.282H23.66V7.282c0-.458-.25-.872-.641-1.1A1.336 1.336 0 0022.363 6a1.334 1.334 0 00-1.133.586l-9.192 13.79v-4.889c0-.708-.592-1.282-1.321-1.282H3.32c-.73 0-1.321.574-1.321 1.282 0 .708.591 1.282 1.32 1.282h6.076v7.95c0 .457.25.871.642 1.1a1.34 1.34 0 00.655.18l.024.001c.44 0 .86-.214 1.109-.586l9.193-13.79z",
  fill: "currentColor"
})));